import React from 'react'
import './about.css'
import ME from '../../assets/me-about.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUser} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
<section id='about'>
  <h5>Get To Know</h5>
  <h2>About Me</h2>
  
  <br />

  <div className="container about_container">
    <div className="about_me">
      <div className="about_me-image">
        <img src={ME} alt="About Image" />
      </div>
    </div>

    <div className="about_content">
    <div className="about_cards">
      <article className='about_card'>
      <FaAward className='avout_icon'/>
      <h5>Experience</h5>
      <small>01+ Year Working</small>
      </article>

      <article className='about_card'>
      <FiUser className='avout_icon'/>
      <h5>Clients</h5>
      <small>60+ Worldwide</small>
      </article>

      <article className='about_card'>
      <VscFolderLibrary className='avout_icon'/>
      <h5>Projects</h5>
      <small>40+ Completed</small>
      </article>
    </div>
    <br />
    <p>
      <h5>I'am a Frontend Web Developer</h5>
      
      Adept at contrubuting to highly collaborative work environment. finding solutions and determining customer satisfaction. Proven experience 
      developing consumer-focused websites using HTML, CSS, Javascript, Bootstrap, React.js and React Native to Built products for desktop and Mobile app user over one year.
      Design and developed web applications across multiple APIs. using third-party integration and databases.
    </p>
    <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  </div>
</section> 
 )
}

export default About